import { render, staticRenderFns } from "./project-lessons.vue?vue&type=template&id=2b194d38&"
import script from "./project-lessons.vue?vue&type=script&lang=js&"
export * from "./project-lessons.vue?vue&type=script&lang=js&"
import style0 from "./project-lessons.vue?vue&type=style&index=0&id=2b194d38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports